
export const Button = ({item}) => {
  return (
    <>
       <button className="w-64 text-lg bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 rounded-lg py-1.5 font-medium text-white "> {item} </button>
    </>
  )
}
